const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const environment = {
    baseUrl: isLocalhost
      ? (window.__API_BASE__ || process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000')
      : ''
}
